import http from '../../services/http-common';


// ✅ Add these imports (Syncfusion PDF)
import {
  PdfDocument, PdfPageSize,PdfBrushes,
  PdfStandardFont, PdfFontFamily, PdfFontStyle,
  gridpdf, PdfPen, PdfColor, PdfSolidBrush,
  PdfStringFormat, PdfTextAlignment, PdfVerticalAlignment,
  PdfBitmap,
  PdfGrid,PdfLayoutType,PdfLayoutFormat
} from "@syncfusion/ej2-pdf-export";
import { PdfPageOrientation } from "@syncfusion/ej2-pdf-export";
import SecurityService from '../security/security.service';
import saleInvoiceService from '../sale-invoice/sale-invoice.service'
import moment from 'moment';
import securityService from '../security/security.service';
class InvoiceService {

  getForList(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/Invoice/list?${queryParams}`);
  }

  getInvoiceDetail(data) {
        let queryParams = new URLSearchParams(data).toString();

    return http.get(`/Invoice/InvoiceDetail?${queryParams}`);
  }

  getNextInvoiceID(InvoiceType = 'SS') {
    return http.get(`/Invoice/NextInvoiceID?InvoiceType=${InvoiceType}`);
  }

  // Dropdown sources (optional)
  getBuyerDDSource() {
    return http.get(`/Invoice/BuyerDDSource`);
  }
  getHSCodeDDSource() {
    return http.get(`/Invoice/HSCodeDDSource`);
  }
  getUnitOfMeasurementDDSource() {
    return http.get(`/Invoice/UnitOfMeasurementDDSource`);
  }

  addRecords(data) {
    return http.post(`/Invoice/add`, data);
  }

  updateMainData(data) {
    return http.put(`/Invoice/update`, data);
  }
  updateDetailData(data) {
    return http.put(`/Invoice/update-detail`, data);
  }
  getProductStock(params) {
    let data = {CompanyID:securityService.getCompanyIDLoggedInUserId(),...params }
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/Invoice/ProductStock?${queryParams}`);
  }

   async getFBRUnitOfMeasurementbyName  (row)  {
    try {
      // ✅ Guard clause (avoid bad API calls)
      if (!row?.hS_CODE) return [];
  
      const CompanyID = SecurityService.getCompanyIDLoggedInUserId();
  
      const data = {
        CompanyID,
        hs_code: row.hS_CODE,
        annexure_id: 3
      };
  
  
      const response = await saleInvoiceService.getUOMDDSource(data);
  
      if (!response?.data || !Array.isArray(response.data)) {
        return [];
      }
  
      const selectedUOM = row?.uoM?.toLowerCase();
  
      const uoMDataSource = response.data
        .map((item) => ({
          id: item.uoM_ID,
          value: item.description
        }))
        .filter((item) =>
          item.value?.toLowerCase() === selectedUOM
        );
  
      return uoMDataSource;
  
    } catch (error) {
      console.error("UOM fetch failed:", error);
      return [];
    }
  };
// =========================
// REPORT (Preview / PDF)
// =========================

toNum(v) {
  const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
  return isNaN(n) ? 0 : n;
}



async generateInvoiceReportPDF(mainRow, detailRows, blob) {
  const doc = new PdfDocument();
  doc.pageSettings.size = PdfPageSize.a4;
  doc.pageSettings.orientation = PdfPageOrientation.Portrait;
  doc.pageSettings.margins.all = 8;

  const page = doc.pages.add();
  const g = page.graphics;

  const black = new PdfSolidBrush(new PdfColor(0, 0, 0));
  const linePen = new PdfPen(new PdfColor(0, 0, 0), 1);
  const outerPen = new PdfPen(new PdfColor(0, 0, 0), 1.2);

  const fontTitle = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
  const fontBold = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
  const font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

  const pageW = page.getClientSize().width;

  const x0 = 8;
  const xR = pageW - 8;
  const usableW = xR - x0;

  const txt = (v) => {
    const s = String(v ?? "").trim();
    return s ? s : "";
  };

  const toNum = (v) => {
    const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  };

  const textW = (fnt, s) => {
    try {
      return fnt.measureString(String(s)).width || 0;
    } catch {
      return String(s).length * 5;
    }
  };

  const drawField = (caption, value, capX, y, lineEndX) => {
    const capText = `${(caption || '').toUpperCase()} :`;
    g.drawString(capText, fontBold, null, black, capX, y);
    const startX = capX + textW(fontBold, capText) + 6;
    g.drawLine(linePen, startX, y + 11, lineEndX, y + 11);
    g.drawString(txt(String(value || '').toUpperCase()), font, null, black, startX + 2, y);
  };

  // =========================
  // CHANGE 7: FBR Logo (top-left) + QR Code (top-right)
  // =========================
  const blobToBase64 = (b) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(b);
    });
  };

  const logoSize = 60;
  let y = 10;

  // FBR Logo - top left
  try {
    const FBRIMGresponse = await fetch('/fbr-img.jpg');
    if (FBRIMGresponse.ok) {
      const FBRimageBlob = await FBRIMGresponse.blob();
      const FBRimageBase64 = await blobToBase64(FBRimageBlob);
      const FBRimage = new PdfBitmap(FBRimageBase64);
      g.drawImage(FBRimage, x0, y, logoSize, logoSize);
    }
  } catch (e) { console.warn("FBR logo load failed", e); }

  // QR Code - top right (blob passed as parameter)
  try {
    if (blob) {
      const url = URL.createObjectURL(blob);
      const response = await fetch(url);
      if (response.ok) {
        const imageBlob = await response.blob();
        const imageBase64 = await blobToBase64(imageBlob);
        const qrImage = new PdfBitmap(imageBase64);
        g.drawImage(qrImage, pageW - logoSize - x0, y+5, logoSize + 20, logoSize + 20);
        URL.revokeObjectURL(url);
      }
    }
  } catch (e) { console.warn("QR code load failed", e); }

  // =========================
  // HEADER (Company info centered, logos on sides)
  // =========================
  const companyName = txt((mainRow?.sellerBusinessName || '').toUpperCase());
  const sellerNTN = txt((mainRow?.sellerNTNCNIC || '').toUpperCase());
  const sellerAddress = txt((mainRow?.sellerAddress || '').toUpperCase());

  // Company Name (center)
  const fontCompany = new PdfStandardFont(PdfFontFamily.Helvetica, 18, PdfFontStyle.Bold);
  const wCompany = fontCompany.measureString(companyName).width;
  g.drawString(companyName, fontCompany, null, black, (pageW - wCompany) / 2, y);
  y += 22;

  // NTN (center)
  const ntnLine = (`NTN: ${sellerNTN}`).toUpperCase();
  const fontNTN = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
  const wNTN = fontNTN.measureString(ntnLine).width;
  g.drawString(ntnLine, fontNTN, null, black, (pageW - wNTN) / 2, y);
  y += 20;

  // Address (center)
  // const fontAddress = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
  // const wAddr = fontAddress.measureString(sellerAddress).width;
  // g.drawString(sellerAddress, fontAddress, null, black, (pageW - wAddr) / 2, y);
  // y += 18;
  const sellerAddrText = String(mainRow?.sellerAddress ?? '').toUpperCase();

const addrFont       = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
const addrLineHeight = 18;

// width limit (same logic as before)
const addrMaxWidth = pageW - 210;

const words   = sellerAddrText.split(' ');
const lines   = [];
let current   = '';

for (const word of words) {
  const testLine  = current ? `${current} ${word}` : word;
  const testWidth = addrFont.measureString(testLine).width;

  if (testWidth > addrMaxWidth && current) {
    lines.push(current);
    current = word;
  } else {
    current = testLine;
  }
}

if (current) lines.push(current);

// Draw centered WITHOUT underline
lines.forEach(line => {
  const lineWidth = addrFont.measureString(line).width;
  const x = (pageW - lineWidth) / 2;

  g.drawString(line, addrFont, null, black, x, y);
  y += addrLineHeight;
});

  // Invoice heading (center)
  const invoiceTitle = mainRow?.InvoiceType == "SS" ? "SALES TAX INVOICE" : "PURCHASE TAX INVOICE";
  const wInv = fontTitle.measureString(invoiceTitle).width;
  g.drawString(invoiceTitle, fontTitle, null, black, (pageW - wInv) / 2, y);
  y += 28;

  // =========================
  // CHANGE 4: Invoice No | Date | Reference No. (ChallanNo) — ONE ROW
  // =========================
  const invoiceNo = txt(mainRow?.InvoiceID);
  const invDate = mainRow?.InvoiceDate
    ? moment(mainRow.InvoiceDate).format("DD-MMM-YYYY")
    : "";
  const challanNo = txt(mainRow?.ChallanNo);

  // 3 fields in one row: Invoice No (0-33%), Date (33-66%), Reference No. (66-100%)
  const col3W = Math.floor(usableW / 3);
  drawField("Invoice No",    invoiceNo,  x0,                   y, x0 + col3W - 8);
  drawField("Date",          invDate,    x0 + col3W,           y, x0 + col3W * 2 - 8);
  drawField("Reference No.", challanNo,  x0 + col3W * 2,       y, xR);
  y += 25;

  // =========================
  // CHANGE 5: Buyer + FBRSaleInvoiceNo in ONE ROW
  // =========================
  let captionCondition = mainRow?.InvoiceType == "SS" ? "Buyer's Name" : "Seller Name";
  const buyerEndX = x0 + Math.floor(usableW * 0.55);
  drawField(captionCondition,     (mainRow?.buyerBusinessName || mainRow?.BuyerNTNCNIC), x0,        y, buyerEndX);
  drawField("FBR Invoice No.",    mainRow?.FBRSaleInvoiceNo,                             buyerEndX + 4, y, xR);
  y += 25;

  // Address
  drawField("Address", mainRow?.buyerAddress, x0, y, xR);
  y += 25;

  // Phone + Sales Tax + NTN (3 fields, no overlap)
  const phoneCapX    = x0;
  const salesTaxCapX = x0 + Math.floor(usableW * 0.34);
  const ntnCapX      = x0 + Math.floor(usableW * 0.68);

  drawField("Phone #",          mainRow?.buyerContactNumber, phoneCapX,    y, salesTaxCapX - 12);
  drawField("Sales Tax Regn #", mainRow?.buyerSTRN,          salesTaxCapX, y, ntnCapX - 12);
  drawField("N.T.N #",          mainRow.buyerNTNCNIC && mainRow.BuyerNTNCNIC.length  == 13 ? mainRow.BuyerNTNCNIC :mainRow?.buyerNTNCNICReferenceNo,        ntnCapX,      y, xR);
  y += 25;

  // =========================
  // CHANGE 6: REMARKS — full row, below NTN
  // =========================
  drawField("Remarks", mainRow?.Remarks, x0, y, xR);
  y += 25;

  // =========================
  // CHANGE 1 & 2: TABLE — Remove FBR QTY/UNIT, Add HSCODE after UNIT
  // New columns: QUANTITY | UNIT | HSCODE | DESCRIPTION | UNIT PRICE | VALUE | TAX RATE | TAX AMT | TOTAL
  // =========================
  const clientW  = page.getClientSize().width;
  const tableX   = 0;
  const tableW   = clientW;
  const grid     = new PdfGrid();
  grid.columns.add(9);   // 9 columns now

  if (!grid.style) grid.style = {};
  grid.style.cellPadding = { left: 2, right: 3, top: 3, bottom: 3 };
  grid.style.font = font;

  const colP = (p) => tableW * p;

  const cQty   = colP(0.08);  // QUANTITY
  const cUnit  = colP(0.08);  // UNIT
  const cHS    = colP(0.09);  // HSCODE  ← NEW
  const cDesc  = colP(0.22);  // DESCRIPTION
  const cUP    = colP(0.10);  // UNIT PRICE
  const cVal   = colP(0.10);  // VALUE
  const cTR    = colP(0.09);  // TAX RATE
  const cTA    = colP(0.10);  // TAX AMT
  const cTot   = Math.floor(tableW - (cQty + cUnit + cHS + cDesc + cUP + cVal + cTR + cTA)); // TOTAL (remainder)

  grid.columns.getColumn(0).width = cQty;
  grid.columns.getColumn(1).width = cUnit;
  grid.columns.getColumn(2).width = cHS;
  grid.columns.getColumn(3).width = cDesc;
  grid.columns.getColumn(4).width = cUP;
  grid.columns.getColumn(5).width = cVal;
  grid.columns.getColumn(6).width = cTR;
  grid.columns.getColumn(7).width = cTA;
  grid.columns.getColumn(8).width = cTot;

  // Header row
  const header    = grid.headers.add(1)[0];
  const headerFmt = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

  const headers = [
    "QUANTITY",
    "UNIT",
    "HS CODE",
    "DESCRIPTION OF GOODS",
    "UNIT\nPRICE",
    "VALUE OF\nGOODS",
    "RATE OF\nSALES\nTAX",
    "VALUE\nOF SALES\nTAX",
    "TOTAL VALUE"
  ];

  headers.forEach((h, i) => {
    header.cells.getCell(i).value = h;
    header.cells.getCell(i).style.font = fontBold;
    header.cells.getCell(i).style.stringFormat = headerFmt;
  });

  // Data rows
  let sumQty = 0, sumValue = 0, sumTax = 0, sumTotal = 0;

  (detailRows || []).forEach((r) => {
    const qty    = toNum(r?.Quantity);
    const rate   = toNum(r?.Rate);
    const bill   = toNum(r?.BillAmount) || (qty * rate);
    const taxPer = toNum(r?.TaxPercent);
    const taxAmt = toNum(r?.TaxAmount)  || (bill * (taxPer / 100));
    const total  = toNum(r?.TotalAmount) || (bill + taxAmt);

    sumQty   += qty;
    sumValue += bill;
    sumTax   += taxAmt;
    sumTotal += total;

    const row = grid.rows.addRow();

    row.cells.getCell(0).value = qty ? qty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
    row.cells.getCell(0).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);

    row.cells.getCell(1).value = r?.UnitOfMeasurement || "";
    row.cells.getCell(1).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    // CHANGE 2: HSCODE
    row.cells.getCell(2).value = txt(r?.hS_CODE || "");
    row.cells.getCell(2).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    row.cells.getCell(3).value = txt((r?.ProductDescription || '').toUpperCase());
    row.cells.getCell(3).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    row.cells.getCell(4).value = rate.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(5).value = bill.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(6).value = taxPer.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(7).value = taxAmt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(8).value = total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    [0, 4, 5, 6, 7, 8].forEach((c) => {
      row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
    });
  });

  // Total row
  const tr = grid.rows.addRow();
  tr.cells.getCell(0).value = sumQty ? sumQty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
  tr.cells.getCell(1).value = "";
  tr.cells.getCell(2).value = "";
  tr.cells.getCell(3).value = "";
  tr.cells.getCell(4).value = "";
  tr.cells.getCell(5).value = sumValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  tr.cells.getCell(6).value = "";
  tr.cells.getCell(7).value = sumTax.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  tr.cells.getCell(8).value = sumTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  for (let i = 0; i < tr.cells.count; i++) {
    tr.cells.getCell(i).style.font = fontBold;
    tr.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  }

  y += 22;
  const result = grid.draw(page, { x: tableX, y });

  // =========================
  // CHANGE 3: SIGNATURE — Only PREPARED BY and RECEIVED BY (APPROVED BY removed)
  // =========================
  const signY    = result.bounds.y + result.bounds.height + 90;
  const lineW    = 120;
  const signFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Regular);
  const signPen  = new PdfPen(new PdfColor(0, 0, 0), 1);

  const leftX  = tableX + 50;
  const rightX = tableX + tableW - lineW - 50;

  const drawSign = (label, x) => {
    g.drawLine(signPen, x, signY, x + lineW, signY);
    const w = signFont.measureString(label).width;
    g.drawString(label, signFont, null, black, x + (lineW - w) / 2, signY + 6);
  };

  drawSign("PREPARED BY", leftX);
  drawSign("RECEIVED BY", rightX);

  // Outer border
  g.drawRectangle(outerPen, result.bounds.x, result.bounds.y, result.bounds.width, result.bounds.height);

  // Save
  let fileName = mainRow?.InvoiceType == "SS" ? 'SALE' : 'PURCHASE';
  const file = `INV_${fileName}_${invoiceNo}.pdf`;
  doc.save(file);
  doc.destroy();
  return null;
}



// PREVIEW D 
wrapText(graphics, text, font, brush, x, y, maxWidth, lineHeight) {
    const words = String(text ?? "").split(" ");
    let line = "";
    let yOffset = y;
  
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const testWidth = font.measureString(testLine).width;
  
      if (testWidth > maxWidth && i > 0) {
        graphics.drawString(line.trim(), font, null, brush, x, yOffset);
        line = words[i] + " ";
        yOffset += lineHeight;
      } else {
        line = testLine;
      }
    }
  
    if (line) {
      graphics.drawString(line.trim(), font, null, brush, x, yOffset);
    }
  
    // IMPORTANT: return last drawn Y so caller can continue below it
    return yOffset;
  }








  //  ==== CALL SALE INVOICE REPORT SERVICES ======

       convertNumberToWords(num) {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
    "Eighty", "Ninety"
  ];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function numberToWords(n) {
    if (n === 0) return "Zero";
    if (n < 20) return units[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");

    for (let scale of scales) {
      if (n >= scale.value) {
        const quotient = Math.floor(n / scale.value);
        const remainder = n % scale.value;
        return (
          numberToWords(quotient) +
          " " +
          scale.name +
          (remainder ? " " + numberToWords(remainder) : "")
        );
      }
    }
    return "";
  }

  const whole = Math.floor(num);
  const fraction = Math.round((num - whole) * 100);

  let result = numberToWords(whole) + " Rupees";
  result += " and " + numberToWords(fraction) + " Paise";

  return result;
}


async generateInvoiceReportPDFD(mainRow, detailRows, blob) {
  console.log(mainRow)
     const document = new PdfDocument();
    
      // Page settings
      document.pageSettings.margins.all = 10;
      document.pageSettings.margins.bottom = 5;
      document.pageSettings.size = PdfPageSize.a4;
    
      // Add page
      const page = document.pages.add();
      const graphics = page.graphics;
     const gridpdf     = new PdfGrid();
      // Fonts & brushes
      const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 16, PdfFontStyle.Bold);
      const subFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
      const subBoldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8, PdfFontStyle.Bold);
      const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
      const boldFonts = new PdfStandardFont(PdfFontFamily.Helvetica, 10, PdfFontStyle.Bold);
      
      const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
      const pageWidth = page.getClientSize().width;
  
  const fontTitle = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
    const fontBold = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    const font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);
    const txt = (v) => {
      const s = String(v ?? "").trim();
      return s ? s : "";
    };
  
    const toNum = (v) => {
      const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
      return isNaN(n) ? 0 : n;
    };
  
  
  
  
      
   // MAIN SECTION START
   
      graphics.drawString("SALES TAX INVOICE", headerFont, null, blackBrush, 200, 30);
  
      graphics.drawString("SOFTWARE  ID:", boldFont, null, blackBrush, 350, 80);
      graphics.drawString(`${String(mainRow?.InvoiceID ?? '').padStart(4, '0')}`, subFont, null, blackBrush, 440, 81);
      graphics.drawString("DATE:", boldFont, null, blackBrush, 350, 95);
      graphics.drawString(`${moment(mainRow.InvoiceDate).format("DD-MMM-YY")}`, subFont, null, blackBrush, 440, 96);
    
     
  
      // ---------- helpers ----------
  // const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";
  
  const lineH10 = 10;     // for wrap text
  const rowGap = 15;      // standard row vertical gap
   let y = 10;
  const buyerX = 10;
  const sellerX = 350;
  
  const buyerLabelX = buyerX;
  const sellerLabelX = sellerX;
  
  // fixed indent so values align nicely
  const buyerValueX = buyerX + 90;
  const sellerValueX = sellerX + 90;
  
  // available widths for wrapped values
  const buyerValueWidth = 280 - 90; // block width ~280, minus indent
  const sellerValueWidth = 200 - 90; // block width ~200, minus indent
  
  const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";
  
  const drawOptionalRowPair = (y, caption, buyerVal, sellerVal) => {
    // Row show ONLY if either side has value
    if (!hasValue(buyerVal) && !hasValue(sellerVal)) return y;
  
    // captions on BOTH sides
    graphics.drawString(`${caption}:`, boldFont, null, blackBrush, buyerLabelX, y);
    graphics.drawString(`${caption}:`, boldFont, null, blackBrush, sellerLabelX, y);
  
    // values (only where present)
    const buyerEndY = hasValue(buyerVal)
      ? this.wrapText(graphics, String(buyerVal), subFont, blackBrush, buyerValueX, y + 1, buyerValueWidth, lineH10)
      : y;
  
    const sellerEndY = hasValue(sellerVal)
      ? this.wrapText(graphics, String(sellerVal), subFont, blackBrush, sellerValueX, y + 1, sellerValueWidth, lineH10)
      : y;
  
    // next row starts after the longer (wrapped) side
    return Math.max(buyerEndY, sellerEndY) + rowGap;
  };
  
  // ---------- Reference No. above INVOICE ----------
  let leftTopY = 80; // above your INVOICE line at y=35
  if (hasValue(mainRow?.InvoiceReferenceNo)) {
    graphics.drawString("REFERENCE NO.:", boldFont, null, blackBrush, buyerLabelX, leftTopY);
    this.wrapText(
      graphics,
      String(mainRow.InvoiceReferenceNo || '').toUpperCase(),
      subFont,
      blackBrush,
      buyerLabelX + 90,
      leftTopY + 1,
      buyerValueWidth,
      lineH10
    );
  }
  
  // ---------- INVOICE (same as before) ----------
  graphics.drawString("FBR INVOICE NO.:", boldFont, null, blackBrush, 10, 95);
  graphics.drawString(`${String(mainRow?.FBRSaleInvoiceNo ?? "").toUpperCase()}`, subFont, null, blackBrush, 100, 96);
  
  // ---------- BUYER block ----------
  graphics.drawString("BUYER:", boldFont, null, blackBrush, buyerLabelX, 120);
  
  let buyerY = 135;
  buyerY = this.wrapText(
    graphics,
    String(mainRow?.buyerBusinessName ?? "").toUpperCase(),
    // subFont,
    subBoldFont,
    blackBrush,
    buyerLabelX,
    buyerY,
    280,
    lineH10
  ) + lineH10;
  
  buyerY = this.wrapText(
    graphics,
    String(mainRow?.buyerAddress ?? "").toUpperCase(),
    subFont,
    blackBrush,
    buyerLabelX,
    buyerY,
    270,
    lineH10
  ) + rowGap;
  
  
  // ---------- SELLER block ----------
  graphics.drawString("SELLER:", boldFont, null, blackBrush, sellerLabelX, 120);
  
  let sellerY = 135;
  sellerY = this.wrapText(
    graphics,
    String(mainRow?.sellerBusinessName ?? "").toUpperCase(),
    // subFont,
    subBoldFont,
    blackBrush,
    sellerLabelX,
    sellerY,
    200,
    lineH10
  ) + lineH10;
  
  sellerY = this.wrapText(
    graphics,
    String(mainRow?.sellerAddress ?? "").toUpperCase(),
    subFont,
    blackBrush,
    sellerLabelX,
    sellerY,
    200,
    lineH10
  ) + rowGap;
  
  
  let commonY = Math.max(buyerY, sellerY);
  buyerY = sellerY = commonY;
  
  // Optional rows (row-level OR)
  commonY = drawOptionalRowPair(
    commonY,
    "CONTACT PERSON",
    mainRow?.buyerContactPerson || '',
    mainRow?.sellerContactPerson || 'T'
  );
  
  commonY = drawOptionalRowPair(
    commonY,
    "CONTACT NO.",
    mainRow?.buyerContactNumber || '',
    mainRow?.sellerContactNumber || ''
  );
  
  commonY = drawOptionalRowPair(
    commonY,
    "STRN",
    mainRow?.buyerSTRN || '',
    mainRow?.sellerSTRN || ''
  );
  
  commonY = drawOptionalRowPair(
    commonY,
    "CNIC NO.",
    mainRow?.buyerCNIC,
    mainRow?.sellerCNIC
  );
  
  buyerY = sellerY = commonY; // keep both aligned for REGION/NTN/TYPE etc
  
  // BUYER mandatory rows
  graphics.drawString("REGION:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(mainRow?.buyerProvinceName ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  graphics.drawString("NTN:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(mainRow.buyerNTNCNIC && mainRow.BuyerNTNCNIC.length  == 13 ? mainRow.BuyerNTNCNIC :mainRow?.buyerNTNCNICReferenceNo || "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  graphics.drawString("TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(!mainRow?.buyerRegistrationType  || mainRow?.buyerRegistrationType  == 'null' ?  "" : mainRow?.buyerRegistrationType ?? '').toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  graphics.drawString("SALE TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(mainRow?.transactioN_Desc ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  // SELLER mandatory rows
  graphics.drawString("REGION:", boldFont, null, blackBrush, sellerLabelX, sellerY);
  graphics.drawString(String(mainRow?.SellerProvinceName ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
  sellerY += rowGap;
  
  graphics.drawString("NTN:", boldFont, null, blackBrush, sellerLabelX, sellerY);
  // graphics.drawString(String(mainRow?.sellerNTN ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
  graphics.drawString(String(
    mainRow?.sellerNTNCNICReferenceNo &&
    mainRow?.sellerNTNCNICReferenceNo.length >= 7
      ? mainRow.sellerNTNCNIC
      : mainRow?.sellerNTNCNIC ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
  sellerY += rowGap;
  
  graphics.drawString("TYPE:", boldFont, null, blackBrush, sellerLabelX, sellerY);
  graphics.drawString("REGISTERED", subFont, null, blackBrush, sellerValueX, sellerY + 1);
  sellerY += rowGap;
  
  // ---------- Use this to place table automatically below header blocks ----------
  const tableStartY = Math.max(180, Math.max(buyerY, sellerY) + 5);
      // MAIN  SECTION  END
  
  
  
  
  
  
  
  
  
  
    // =========================
    // CHANGE 1 & 2: TABLE — Remove FBR QTY/UNIT, Add HSCODE after UNIT
    // New columns: QUANTITY | UNIT | HSCODE | DESCRIPTION | UNIT PRICE | VALUE | TAX RATE | TAX AMT | TOTAL
    // =========================
   
    const clientW  = page.getClientSize().width;
    const tableX   = 0;
    const tableW   = clientW;
    gridpdf.columns.add(9);   // 9 columns now
  
    if (!gridpdf.style) gridpdf.style = {};
    gridpdf.style.cellPadding = { left: 2, right: 3, top: 3, bottom: 3 };
    gridpdf.style.font = font;
  
    const colP = (p) => tableW * p;
  
    const cQty   = colP(0.08);  // QUANTITY
    const cUnit  = colP(0.08);  // UNIT
    const cHS    = colP(0.09);  // HSCODE  ← NEW
    const cDesc  = colP(0.22);  // DESCRIPTION
    const cUP    = colP(0.10);  // UNIT PRICE
    const cVal   = colP(0.10);  // VALUE
    const cTR    = colP(0.09);  // TAX RATE
    const cTA    = colP(0.10);  // TAX AMT
    const cTot   = Math.floor(tableW - (cQty + cUnit + cHS + cDesc + cUP + cVal + cTR + cTA)); // TOTAL (remainder)
  
    gridpdf.columns.getColumn(0).width = cQty;
    gridpdf.columns.getColumn(1).width = cUnit;
    gridpdf.columns.getColumn(2).width = cHS;
    gridpdf.columns.getColumn(3).width = cDesc;
    gridpdf.columns.getColumn(4).width = cUP;
    gridpdf.columns.getColumn(5).width = cVal;
    gridpdf.columns.getColumn(6).width = cTR;
    gridpdf.columns.getColumn(7).width = cTA;
    gridpdf.columns.getColumn(8).width = cTot;
  
    // Header row
    const header    = gridpdf.headers.add(1)[0];
    const headerFmt = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);
  
    const headers = [
      "QUANTITY",
      "UNIT",
      "HS CODE",
      "DESCRIPTION OF GOODS",
      "UNIT\nPRICE",
      "VALUE OF\nGOODS",
      "RATE OF\nSALES\nTAX",
      "VALUE\nOF SALES\nTAX",
      "TOTAL VALUE"
    ];
  
    // headers.forEach((h, i) => {
    //   header.cells.getCell(i).value = h;
    //   header.cells.getCell(i).style.font = fontBold;
    //   header.cells.getCell(i).style.stringFormat = headerFmt;
    // });
  
    
  const headersboldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
  
  const styleHeaderCell = (cell) => {
    cell.style.font = headersboldFont;
    cell.style.stringFormat = headerFmt;
    cell.style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 150, 100)); // teal blue
    cell.style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));     // white text
  };
  headers.forEach((col, i) => {
    const cell = header.cells.getCell(i);
    cell.value = col;
    styleHeaderCell(cell);
  });
  
  
    // Data rows
    let sumQty = 0, sumValue = 0, sumTax = 0, sumTotal = 0;
  
    (detailRows || []).forEach((r) => {
      const qty    = toNum(r?.Quantity);
      const rate   = toNum(r?.Rate);
      const bill   = toNum(r?.BillAmount) || (qty * rate);
      const taxPer = toNum(r?.TaxPercent);
      const taxAmt = toNum(r?.TaxAmount)  || (bill * (taxPer / 100));
      const total  = toNum(r?.TotalAmount) || (bill + taxAmt);
  
      sumQty   += qty;
      sumValue += bill;
      sumTax   += taxAmt;
      sumTotal += total;
  
      const row = gridpdf.rows.addRow();
  
      row.cells.getCell(0).value = qty ? qty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
      row.cells.getCell(0).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  
      row.cells.getCell(1).value = r?.UnitOfMeasurement || "";
      row.cells.getCell(1).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);
  
      // CHANGE 2: HSCODE
      row.cells.getCell(2).value = txt(r?.hS_CODE || "");
      row.cells.getCell(2).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);
  
      row.cells.getCell(3).value = txt((r?.ProductDescription || '').toUpperCase());
      row.cells.getCell(3).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);
  
      row.cells.getCell(4).value = rate.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(5).value = bill.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(6).value = taxPer.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(7).value = taxAmt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(8).value = total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
      [0, 4, 5, 6, 7, 8].forEach((c) => {
        row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
      });
    });
  
    // // Total row
    // const tr = gridpdf.rows.addRow();
    // tr.cells.getCell(0).value = sumQty ? sumQty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
    // tr.cells.getCell(1).value = "";
    // tr.cells.getCell(2).value = "";
    // tr.cells.getCell(3).value = "";
    // tr.cells.getCell(4).value = "";
    // tr.cells.getCell(5).value = sumValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // tr.cells.getCell(6).value = "";
    // tr.cells.getCell(7).value = sumTax.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // tr.cells.getCell(8).value = sumTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
    // for (let i = 0; i < tr.cells.count; i++) {
    //   tr.cells.getCell(i).style.font = fontBold;
    //   tr.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
    // }
  
    y += 22;
    // const result = gridpdf.draw(page, { x: tableX, y });
  
  
  
  // IMAGE FOOTER COMPLETED
  const layoutResult = gridpdf.draw(page, { x: tableX, y: tableStartY });
  
      console.log(sumTotal)
      let TotalAmountSum = this.convertNumberToWords(sumTotal.toFixed(2)) + " Only"
      console.log(TotalAmountSum)
      let yBase = layoutResult.bounds.y + layoutResult.bounds.height + 25;
  
      graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
      this.wrapText(
        graphics,
        String(TotalAmountSum),
        boldFont,
        blackBrush,
        10,
        yBase + 15,
        300,
        15
      );
  
  
  // rectangle box start
  
  
      let xPos = page.getClientSize().width - 250;  // right aligned box
  let yPos = layoutResult.bounds.height + layoutResult.bounds.y + 20; 
  let boxWidth = 220;
  let boxHeight = 80;
  
  graphics.drawRectangle(new PdfPen(PdfColor.black, 1), xPos, yPos, boxWidth, boxHeight);
  
  let lineHeight = 14;
  let padding = 5;
  
  // Function to measure and right-align text
  function drawRightAligned(text, yOffset, font) {
      let textWidth = font.measureString(text).width;
      let drawX = xPos + boxWidth - padding - textWidth; // right edge inside box
      let drawY = yPos + yOffset;
      graphics.drawString(text, font, null, PdfBrushes.black, drawX, drawY);
  }
  drawRightAligned(`QUANTITY: ${(sumQty || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8, subFont);
  drawRightAligned(`VALUE OF GOODS: ${(sumValue || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
  drawRightAligned(`VALUE OF SALES TAX: ${(sumTax || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 2, subFont);
  drawRightAligned(
    `Grand Total Value : Rs. ${(sumTotal || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    6 + lineHeight * 4,
    boldFont
  );
  // rectangle box end
  
  
  
      //  // ===== IMAGE (Base64 PNG) =====
      const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
      };
    
    
        const url = URL.createObjectURL(blob);
  
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
      
        const imageBlob = await response.blob();
        const imageBase64 = await blobToBase64(imageBlob);
      
       // Create PdfBitmap from Base64
       const image = new PdfBitmap(imageBase64);
         
       // Draw the image on the PDF
       let xImgPos = page.getClientSize().width - 115;  // right aligned box
        let yImgPos = layoutResult.bounds.height + layoutResult.bounds.y + 140; 
       graphics.drawImage(image, xImgPos, yImgPos,96 ,96 ); // Adjust x, y, width, height as needed
        
  
  
       // ==== FBR IMAGE DRAW ====
       const FBRIMGresponse = await fetch('/fbr-img.jpg');
       if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
       
               const FBRimageBlob = await FBRIMGresponse.blob();
               const FBRimageBase64 = await blobToBase64(FBRimageBlob);
       
              // Create PdfBitmap from Base64
              const FBRimage = new PdfBitmap(FBRimageBase64);
                
              // Draw the FBRimage on the PDF
              graphics.drawImage(FBRimage, 40, yImgPos,50 ,50 ); // Adjust x, y, width, height as needed
              graphics.drawString(
                " THIS IS A SYSTEM GENERATED DIGITAL INVOICE. NO SIGNATURE REQUIRED",
                subFont,
                null,
                blackBrush,
                pageWidth / 2 - 150,
                yImgPos + 150
              );
              graphics.drawString(
              mainRow?.Remarks,
              boldFonts,
                null,
                blackBrush,
                pageWidth / 2 -40,
                yImgPos + 170
              );
              
  
      let partyName = (mainRow?.buyerBusinessName || '')
    .toUpperCase()
    .split(/\s+/)[0]; 
  
        document.save(`INV_D_${partyName}_${mainRow?.InvoiceID}.pdf`);
        document.destroy();
  }

  




  /// PREVIW F
  // ============================================================
//  REPORT F  –  Sale Invoice (Farah Towel Factory Layout)
//  Matches: farahbleaching.pdf  |  Source reference: Preview D
//
//  GRID COLUMNS (12):
//  1  SR NO.
//  2  PRODUCT DESCRIPTION
//  3  HS CODE
//  4  UOM                 → static box below = "Pound"
//  5  QUANTITY            → calc box below  = Qty * 2.2046
//  6  RATE                → calc box below  = Rate / 2.2046
//  7  Value Sales Excl ST
//  8  Rate of Sales Tax %
//  9  Sales Tax Applicable
//  10 Further Tax Rate %  (default 0)
//  11 Extra Tax           (default 0)
//  12 Total Values
//
//  NOTE: "Value" and "Disc" columns are NOT shown (per requirement)
// ============================================================

convertNumberToWordsF(num) {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
    "Eighty", "Ninety"
  ];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000,   name: "Lakh" },
    { value: 1000,     name: "Thousand" },
    { value: 100,      name: "Hundred" }
  ];

  function numberToWords(n) {
    if (n === 0) return "Zero";
    if (n < 20)  return units[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");
    for (let scale of scales) {
      if (n >= scale.value) {
        const q = Math.floor(n / scale.value);
        const r = n % scale.value;
        return numberToWords(q) + " " + scale.name + (r ? " " + numberToWords(r) : "");
      }
    }
    return "";
  }

  const whole    = Math.floor(num);
  const fraction = Math.round((num - whole) * 100);
  return numberToWords(whole) + " Rupees" +
         " and " + numberToWords(fraction) + " Paise";
}

// ────────────────────────────────────────────────────────────
async generateInvoiceReportPDFF(mainRow, detailRows, blob) {
  console.log("generateInvoiceReportPDFF →", mainRow);

  // ── document setup ──────────────────────────────────────
  const document = new PdfDocument();
  document.pageSettings.margins.all    = 10;
  document.pageSettings.margins.bottom = 5;
  document.pageSettings.size           = PdfPageSize.a4;

  const page      = document.pages.add();
  let graphics  = page.graphics;
  const gridpdf   = new PdfGrid();
  gridpdf.repeatHeader = true;

  const pageWidth = page.getClientSize().width;

  // ── fonts ───────────────────────────────────────────────
  const fCompanyName = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
  const fTitle       = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
  const fBold7       = new PdfStandardFont(PdfFontFamily.Helvetica,  8, PdfFontStyle.Bold);
  const fBold8       = new PdfStandardFont(PdfFontFamily.Helvetica,  8, PdfFontStyle.Bold);
  const fBold9       = new PdfStandardFont(PdfFontFamily.Helvetica,  9, PdfFontStyle.Bold);
  const fNormal7     = new PdfStandardFont(PdfFontFamily.Helvetica,  8);
  const fNormal6     = new PdfStandardFont(PdfFontFamily.Helvetica,  7);
  const fBold6       = new PdfStandardFont(PdfFontFamily.Helvetica,  7, PdfFontStyle.Bold);
  const fGridHeader  = new PdfStandardFont(PdfFontFamily.Helvetica,  8, PdfFontStyle.Bold);

  // ── brushes ─────────────────────────────────────────────
  const blackBrush  = new PdfSolidBrush(new PdfColor(0,   0,   0));
  const whiteBrush  = new PdfSolidBrush(new PdfColor(255, 255, 255));
  const grayBrush   = new PdfSolidBrush(new PdfColor(190, 190, 190));

  // ── helpers ─────────────────────────────────────────────
  const up = (v) => String(v ?? "").toUpperCase();
  const txt   = (v)  => String(v ?? "").trim().toUpperCase();
  const toNum = (v)  => {
    const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  };
  const fmt2  = (n)  => (n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const hasV  = (v)  => v !== null && v !== undefined && String(v).trim() !== "";

  // ── base64 helper ────────────────────────────────────────
  const blobToBase64 = (b) =>
    new Promise((res, rej) => {
      const r  = new FileReader();
      r.onloadend = () => res(r.result.split(",")[1]);
      r.onerror   = rej;
      r.readAsDataURL(b);
    });

  // ============================================================
  //  SECTION 1 – COMPANY HEADER
  // ============================================================
  let curY = 8;

  // Company name (underlined via drawing a line)
  graphics.drawString(
    String(mainRow?.sellerBusinessName ?? "").toUpperCase(),
    fCompanyName, null, blackBrush, 10, curY
  );
  const compNameW = fCompanyName.measureString(String(mainRow?.sellerBusinessName ?? "").toUpperCase(),).width;
  graphics.drawLine(
    new PdfPen(new PdfColor(0, 0, 0), 0.9),
    10, curY + 16, 10 + compNameW, curY + 16
  );

  // Address lines
  graphics.drawString(
    txt(mainRow?.sellerAddress || "LOT.NO. LS-31, SECTOR 6-D, ORANGI TOWN KARACHI."),
    fNormal7, null, blackBrush, 10, curY + 18
  );
  // graphics.drawString("Contact Email :", fBold7, null, blackBrush, 10, curY + 28);
  // graphics.drawString("Website :",       fBold7, null, blackBrush, 10, curY + 38);

  // ── FBR logo (top-right) ─────────────────────────────────
  try {
    const FBRResp  = await fetch("/fbr-img.jpg");
    if (FBRResp.ok) {
      const FBRBlob   = await FBRResp.blob();
      const FBRBase64 = await blobToBase64(FBRBlob);
      const FBRImg    = new PdfBitmap(FBRBase64);
      graphics.drawImage(FBRImg, pageWidth - 150, 5, 60, 60);
    }
  } catch (e) { console.warn("FBR image load failed:", e); }

  // ── QR / signature image (top-right of FBR logo) ─────────
  if (blob) {
    try {
      const url      = URL.createObjectURL(blob);
      const resp     = await fetch(url);
      const imgBlob  = await resp.blob();
      const imgB64   = await blobToBase64(imgBlob);
      const qrImg    = new PdfBitmap(imgB64);
      graphics.drawImage(qrImg, pageWidth - 80, 10, 90, 90);
    } catch (e) { console.warn("QR image load failed:", e); }
  }

  // Separator line
  curY += 80;
  graphics.drawLine(
    new PdfPen(new PdfColor(0, 0, 0), 0.7),
    10, curY, pageWidth - 10, curY
  );

  // ============================================================
  //  SECTION 2 – TITLE + NTN
  // ============================================================
  curY += 10;
  const titleText  =up("Sales Tax Invoice") || "Sales Tax Invoice";
  const titleW     = fTitle.measureString(titleText).width;
  graphics.drawString(titleText, fTitle, null, blackBrush, (pageWidth - titleW) / 2, curY);

  curY += 26;
  graphics.drawLine(
    new PdfPen(new PdfColor(0, 0, 0), 0.7),
    10, curY, pageWidth - 10, curY
  );
  
  curY += 8;
  const ntnText    = up(`NTN : ${txt(mainRow?.sellerNTNCNIC || mainRow?.sellerNTNCNICReferenceNo || "")}`);
  const ntnTextW   = fBold7.measureString(ntnText).width;
  graphics.drawString(ntnText, fBold7, null, blackBrush, (pageWidth - ntnTextW) / 2, curY);

  // ============================================================
  //  SECTION 3 – BUYER (left) | INVOICE INFO (right)
  // ============================================================
  curY += 14;

  const LEFT_X      = 10;
  const LEFT_LBL_W  = 70;
  const LEFT_VAL_X  = LEFT_X + LEFT_LBL_W + 8;
  const RIGHT_X     = pageWidth / 2 + 10;
  const RIGHT_LBL_W = 80;
  const RIGHT_VAL_X = RIGHT_X + RIGHT_LBL_W;
  const ROW_H       = 14;

  const drawInfoLine = (lLbl, lVal, rLbl, rVal, y) => {
    if (lLbl) graphics.drawString(up(`${lLbl} :`), fBold7, null, blackBrush, LEFT_X,      y);
    if (lVal) graphics.drawString(txt(lVal),     fNormal7, null, blackBrush, LEFT_VAL_X,  y);
    if (rLbl) graphics.drawString(up(`${rLbl} :`),   fBold7, null, blackBrush, RIGHT_X,    y);
    if (rVal) graphics.drawString(txt(rVal),      fNormal7, null, blackBrush, RIGHT_VAL_X, y);
    return y + ROW_H;
  };

  curY = drawInfoLine(
    "Customer Name",
    String(mainRow?.buyerBusinessName ?? "").toUpperCase(),
    "Invoice #",
    // `INV-SFA-${String(mainRow?.InvoiceID ?? "").padStart(4,"0")}-26-${String(mainRow?.InvoiceID ?? "").padStart(5,"0")}`,
    `${String(mainRow?.InvoiceID ?? "")}`,
    curY
  );
  
  curY = drawInfoLine(
    "NTN / CNIC #",
    txt(mainRow?.buyerNTNCNIC || mainRow?.buyerNTNCNIC || ""),
    "Invoice Date",
    moment(mainRow?.InvoiceDate).format("DD-MMM-YYYY"),
    curY
  );
  curY = drawInfoLine(
    "Province",
    String(mainRow?.buyerProvinceName ?? "").toUpperCase(),
    "FBR Invoice #",
    txt(mainRow?.FBRSaleInvoiceNo || ""),
    curY
  );
  curY = drawInfoLine(
    "Reg. Type",
    String(mainRow?.buyerRegistrationType ?? "Registered").toUpperCase(),
    "Reference No.",
    txt(mainRow?.InvoiceReferenceNo || ""),
    curY
  );

  // Address (may wrap)
  graphics.drawString(up("Address :"), fBold7, null, blackBrush, LEFT_X, curY);
  const addrEndY = this.wrapText(
    graphics,
    String(mainRow?.buyerAddress ?? "").toUpperCase(),
    fNormal7, blackBrush,
    LEFT_VAL_X, curY,
    (pageWidth / 2) - LEFT_VAL_X - 10, 10
  );
  curY = Math.max(addrEndY, curY) + 10;

  // ============================================================
  //  SECTION 4 – GRID (12 columns)
  // ============================================================
  const tableStartY = curY + 2;
  const tableW      = pageWidth;

  gridpdf.columns.add(10);
  if (!gridpdf.style) gridpdf.style = {};
  gridpdf.style.cellPadding = { left: 2, right: 2, top: 2, bottom: 2 };
  gridpdf.style.font        = fNormal6;

  // Column proportions  (must sum to 1.0)
  const pSR    = 0.04;   // 1  SR NO.
  const pDesc  = 0.16;   // 2  PRODUCT DESCRIPTION
  const pHS    = 0.08;   // 3  HS CODE
  const pUOM   = 0.06;   // 4  UOM
  const pQty   = 0.10;   // 5  QUANTITY
  const pRate  = 0.09;   // 6  RATE
  const pValST = 0.12;   // 7  Value Excl ST
  const pRST   = 0.10;   // 8  Rate of ST %
  const pSTA   = 0.12;   // 9  ST Applicable
  const pFTR   = 0.08;   // 10 Further Tax Rate %
  const pET    = 0.06;   // 11 Extra Tax
  const pTot   = 1 - (pSR + pDesc + pHS + pUOM + pQty + pRate + pValST + pRST + pSTA );

  const colWidths = [pSR, pDesc, pHS, pUOM, pQty, pRate, pValST, pRST, pSTA, pTot]
    .map(p => p * tableW);

  // Store cumulative X positions for pound boxes later
  const colStartX = [];
  let accX = 0;
  colWidths.forEach(w => { colStartX.push(accX); accX += w; });

  colWidths.forEach((w, i) => { gridpdf.columns.getColumn(i).width = w; });

  // ── Header row ──────────────────────────────────────────
  // const headerRow = gridpdf.headers.add(1)[0];
  // const hFmt      = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

  // const HEADER_LABELS = [
  //   "S.N\nd.",
  //   "Product\nDescription",
  //   "HS Code",
  //   "UOM",
  //   "QTY",
  //   "Unit Price",
  //   "Value Sales\nExcluding ST",
  //   "Rate of\nSales Tax\nTax %",
  //   "Sales Tax\nApplicable",
  //   "Further\nTax Rate\n%",
  //   "Extra\nTax",
  //   "Total Values"
  // ];

  // HEADER_LABELS.forEach((lbl, i) => {
  //   const cell = headerRow.cells.getCell(i);
  //   cell.value                    = lbl;
  //   cell.style.font               = fGridHeader;
  //   cell.style.stringFormat       = hFmt;
  //   cell.style.backgroundBrush    = new PdfSolidBrush(new PdfColor(200, 200, 200)); // light grey
  //   cell.style.textBrush          = blackBrush;
  // });

  gridpdf.headers.add(2);


  // ── HEADER ROW 1 (MAIN HEADERS)
const hRow1 = gridpdf.headers.getHeader(0);
const hRow2 = gridpdf.headers.getHeader(1);
const hFmt  = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

// Normal columns (rowspan = 2)
[
  "S.NO.",
  "Product\nDescription",
  "HS Code",
  "UOM",
  "QTY",
  "Unit Price",
  "Value Sales\nExcluding ST"
].map(up).forEach((txt, i) => {
  const cell = hRow1.cells.getCell(i);
  cell.value = txt;
  cell.rowSpan = 2;
  cell.stringFormat = hFmt;
  cell.style.font = fGridHeader;
});

// TAXES GROUP HEADER — now spans only 2 sub-columns (Rate % + Sales Tax)
const taxHeader = hRow1.cells.getCell(7);
taxHeader.value = up("Taxes");  
taxHeader.columnSpan = 2;          // ← was 4, now 2
taxHeader.stringFormat = hFmt;
taxHeader.style.font = fGridHeader;

// TOTAL VALUES (rowspan) — shifted from index 11 → 9
const totalHeader = hRow1.cells.getCell(9);   // ← was 11
totalHeader.value = up("Total Values");
totalHeader.rowSpan = 2;
totalHeader.stringFormat = hFmt;
totalHeader.style.font = fGridHeader;

// ── HEADER ROW 2 (SUB HEADERS UNDER TAXES) — only 2 remain
[
  "Rate of\nSales Tax\n%",
  "Sales Tax\nApplicable",
  // "Further Tax Rate %" removed
  // "Extra Tax" removed
].map(up).forEach((txt, i) => {
  const cell = hRow2.cells.getCell(7 + i);
  cell.value = txt;
  cell.stringFormat = hFmt;
  cell.style.font = fGridHeader;
});

// ── Data rows ───────────────────────────────────────────
let sumQty = 0, sumValue = 0, sumTax = 0, sumTotal = 0;
let srNo   = 0;
const cFmt  = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);
const rFmt  = new PdfStringFormat(PdfTextAlignment.Right,  PdfVerticalAlignment.Middle);
const lFmt  = new PdfStringFormat(PdfTextAlignment.Left,   PdfVerticalAlignment.Middle);

(detailRows || []).forEach((r) => {
  srNo++;
  const qty    = toNum(r?.Quantity);
  const rate   = toNum(r?.Rate);
  const bill   = toNum(r?.BillAmount)  || (qty * rate);
  const taxPer = toNum(r?.TaxPercent);
  const taxAmt = toNum(r?.TaxAmount)   || (bill * (taxPer / 100));
  const total  = toNum(r?.TotalAmount) || (bill + taxAmt);
  // furTax & extTax removed

  sumQty   += qty;
  sumValue += bill;
  sumTax   += taxAmt;
  sumTotal += total;

  const row = gridpdf.rows.addRow();

  // rowSpan columns — 9,10 removed; Total Values now at index 9
  [0, 1, 2, 6, 7, 8, 9].forEach(i => {   // ← was [0,1,2,6,7,8,9,10,11]
    row.cells.getCell(i).rowSpan = 2;
  });

  //  0 – SR NO.
  row.cells.getCell(0).value        = String(srNo);
  row.cells.getCell(0).stringFormat = cFmt;

  //  1 – PRODUCT DESCRIPTION
  row.cells.getCell(1).value        = txt((r?.ProductDescription || "").toUpperCase());
  row.cells.getCell(1).stringFormat = lFmt;

  //  2 – HS CODE
  row.cells.getCell(2).value        = txt(r?.hS_CODE || "");
  row.cells.getCell(2).stringFormat = cFmt;

  //  3 – UOM
  row.cells.getCell(3).value        = txt(r?.UnitOfMeasurement || "KG");
  row.cells.getCell(3).stringFormat = cFmt;

  //  4 – QUANTITY
  row.cells.getCell(4).value        = qty ? qty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
  row.cells.getCell(4).stringFormat = rFmt;

  //  5 – UNIT PRICE / RATE
  row.cells.getCell(5).value        = fmt2(rate);
  row.cells.getCell(5).stringFormat = rFmt;

  //  6 – VALUE EXCLUDING ST
  row.cells.getCell(6).value        = fmt2(bill);
  row.cells.getCell(6).stringFormat = rFmt;

  //  7 – RATE OF SALES TAX %
  row.cells.getCell(7).value        = `${taxPer.toLocaleString("en-US", { maximumFractionDigits: 2 })}%`;
  row.cells.getCell(7).stringFormat = cFmt;

  //  8 – SALES TAX APPLICABLE
  row.cells.getCell(8).value        = fmt2(taxAmt);
  row.cells.getCell(8).stringFormat = rFmt;

  // columns 9 (Further Tax) and 10 (Extra Tax) removed

  //  9 – TOTAL VALUES  (was 11)
  row.cells.getCell(9).value        = fmt2(total);
  row.cells.getCell(9).stringFormat = rFmt;

  // ── Pound sub-row
  const poundRow = gridpdf.rows.addRow();

  poundRow.cells.getCell(0).columnSpan = 3;
  poundRow.cells.getCell(0).value = "";

  poundRow.cells.getCell(3).value        = "POUND";
  poundRow.cells.getCell(3).stringFormat = cFmt;

  poundRow.cells.getCell(4).value        = (qty * 2.2046).toFixed(2);
  poundRow.cells.getCell(4).stringFormat = rFmt;

  poundRow.cells.getCell(5).value        = (rate / 2.2046).toFixed(2);
  poundRow.cells.getCell(5).stringFormat = rFmt;

  poundRow.cells.getCell(6).columnSpan = 4;   // ← was 6, now 4 (cols 6–9)
  poundRow.cells.getCell(6).value = "";
});

// ── Footer row
const footerRow = gridpdf.rows.addRow();

footerRow.cells.getCell(0).columnSpan = 6;
footerRow.cells.getCell(0).value =
  up(this.convertNumberToWordsF(+sumTotal.toFixed(2)) + " ONLY");

footerRow.cells.getCell(6).value        = fmt2(sumValue);
footerRow.cells.getCell(6).stringFormat = rFmt;

// skip col 7 (tax %)

footerRow.cells.getCell(8).value        = fmt2(sumTax);
footerRow.cells.getCell(8).stringFormat = rFmt;

// cols 9,10 skips removed — Total now at 9
footerRow.cells.getCell(9).value        = fmt2(sumTotal);   // ← was 11
footerRow.cells.getCell(9).stringFormat = rFmt;

// Draw grid
const layoutFormat = new PdfLayoutFormat();
layoutFormat.layout = PdfLayoutType.Paginate;

const layoutResult = gridpdf.draw(page, { x: 0, y: tableStartY }, layoutFormat);

const lastPage = layoutResult.page;
const lastBounds = layoutResult.bounds;



 graphics = lastPage.graphics;

// Remarks
let remarksY = lastBounds.y + lastBounds.height + 20;

  // ============================================================
  //  SECTION 9 – REMARKS
  // ============================================================
  // let remarksY = gridBottom + 22;
  graphics.drawString(up("Remarks:"), fBold7, null, blackBrush, 10, remarksY);
  if (hasV(mainRow?.Remarks)) {
    graphics.drawString(txt(mainRow.Remarks), fNormal7, null, blackBrush, 60, remarksY);
  }

  // ============================================================
  //  SECTION 10 – FOOTER
  // ============================================================
 

    const pageHeight = lastPage.getClientSize().height;

    // footer bottom se thoda upar (e.g. 20 margin)
    const footerY = pageHeight - 25;

    const footerText = up("This is computer generated Invoice and does not require signature.") || "This is computer generated Invoice and does not require signature.";
    const footerW = fNormal7.measureString(footerText).width;
    
    graphics.drawString(
      footerText,
      fNormal7,
      null,
      blackBrush,
      (pageWidth - footerW) / 2,
      footerY
    );

    graphics.drawLine(
      new PdfPen(blackBrush, 0.5),
      (pageWidth - footerW) / 2,
      footerY + 10, // thoda neeche line
      (pageWidth - footerW) / 2 + footerW,
      footerY + 10
    );
    
  // Print date & time (right)
  // const footerY     = remarksY + 30;
  const printDT   =  up(`Print Date & Time:  ${moment().format("MMMM D, YYYY h:mm:ss A")}`);
  const printDTW  = fNormal7.measureString(printDT).width;
  graphics.drawString(
    printDT, fNormal7, null, blackBrush,
    pageWidth - printDTW - 10, remarksY + 30
  );

  // ============================================================
  //  SAVE
  // ============================================================
  const partyName = (mainRow?.buyerBusinessName || "")
    .toUpperCase()
    .split(/\s+/)[0];

  document.save(`INV_F_${partyName}_${mainRow?.InvoiceID}.pdf`);
  document.destroy();
}
}




export default new InvoiceService();

